export function fromValues (data, labelKey, valueKey) {
  return data.map((value, index) => {
    return {
      id: index,
      label: value[labelKey],
      value: value[valueKey]
    }
  })
}

export function fromKeys (data, firstObj = {}) {
  data = {
    ...firstObj,
    ...data
  }
  return Object.keys(data).map((key, index) => {
    return {
      id: index,
      label: key,
      value: data[key]
    }
  })
}

export function mapListFilter ({ obj, id, label, value }) {
  return obj.map(el => {
    return {
      id: el[id],
      label: el[label],
      value: el[value]
    }
  })
}
